import {useNavigate} from "react-router-dom";

const HouseCard = ({house}) => {
    const navigate = useNavigate();

    const handleClick = () => {

        navigate(`/detail/house/${house.id}`);
    };

    return (
        <div
            onClick={handleClick}
            className="m-3 w-[320px] h-[400px] duration-300 cursor-pointer rounded-xl overflow-hidden shadow-lg border-2 hover:shadow-2xl hover:bg-white/30 transition flex flex-col"
        >
            <img
                className="w-full h-48 object-cover"
                src={house.media[0]?.url || `/image.png`}
                alt={`${house.title} — ${house.category?.name || 'недвижимость'} в ${house.district || 'Кыргызстане'}`}
                loading="lazy"
            />

            <div className="p-4 flex flex-col flex-grow">
                <h3 className="font-bold text-lg leading-6 mb-2">
                    {house.title}
                </h3>
                <p className="text-gray-800 flex items-start gap-1">
                    <span className="material-icons text-sm mt-0.5">Описание:</span>
                    {house.description.length > 45
                        ? house.description.slice(0, 45) + "..."
                        : house.description}
                </p>
                <p>
                    <span className="font-semibold">Адрес:</span> {house.address}
                </p>
                <p>
                    <span className="font-semibold">Цена:</span> ${house.price_usd}
                </p>

                {/* чтобы дата всегда была снизу */}
                <p className="text-gray-600 flex items-center mt-auto">
      <span className="material-icons text-sm">
        Создано: {house.created_at.slice(0, house.created_at.indexOf("T"))}
      </span>
                </p>
            </div>
        </div>

    );
};

export default HouseCard;
